import { Component, Input, OnInit } from '@angular/core';
import { FuelingClassification } from 'src/app/client-management/parc-management';
import { ChartConfigService } from 'src/app/utils/chart/chart-config.service';
import { ActivityVehiculeClassificationsService } from '../../activity-vehicule-classifications.service';
const Highcharts = require('highcharts');
require('highcharts/modules/exporting')(Highcharts);

@Component({
  selector: 'app-classification-fueling-chart',
  templateUrl: './classification-fueling-chart.component.html',
  styleUrls: ['./classification-fueling-chart.component.css']
})
export class ClassificationFuelingChartComponent implements OnInit {

  classments: FuelingClassification[] = [];
  classmentObject: Object | null = null;

  @Input()
  set fuelings(fuelings: FuelingClassification[]) {
    if (fuelings) {
      this.classments = Object.assign(fuelings);
      this.fuelingChart();
    }
  }
  constructor(private chartConfig: ChartConfigService,
    private classificationService:ActivityVehiculeClassificationsService
  ) { }

  ngOnInit() {
    this.fuelingChart();
  }

  fuelingChart() {
    this.chartConfig.setHighCartsLang();
    var data: { name: string, y: number ,color:string ,avatarUri:string}[] = [];

    this.classments.forEach(fl => {
      data.push({ name: fl.driver, y: fl.cost ,color: this.classificationService.getColorFromName(fl.driver), avatarUri: fl.avatarUri});
    })
    this.classmentObject = {
      chart: {
        type: 'column'
      },
      title: {
        text: 'Carburant',
        style: {
          fontWeight: 'bold'
        }
      },
      credits: {
        enabled: false
      },
      xAxis: {
        type: 'category',

        labels: {
          rotation: -45,
          step: 1,
          style: {
            color: "#000000",
            fontWeight: 'bold',
            textDecoration: "underline"
          }
        }
      },
      yAxis: {
        title: {
          text: 'DHs'
        },
        labels: {
          enabled: false
        }
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        column: {
          borderRadius: 5
        },
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: false,
            format: '{point.y:.2f} '
          }
        }
      },
      tooltip: {
        useHTML: true,
        formatter: function(this: any): string {
          const avatar = this.point.avatarUri ? this.point.avatarUri : '';
          return `
            <div style="display:flex; align-items:center;">
              <img src="${avatar}" style="width:40px; height:40px; border-radius:50%; margin-right:5px;" />
              <div>
                <b>${this.point.name}</b><br/>
                ${this.point.y.toFixed(2)} DH
              </div>
            </div>
          `;
        }
      },
      series: [
        {
          name: "Matricule",
          colorByPoint: true,
          dataLabels: {
            enabled: false,
            format: '{point.y:.2f}'
          }, tooltip: {
            pointFormat: '<span style="color:{point.color}">{point.name} </span> <br><b>{point.y:.2f} DH</b> <br/>'
          },
          data: data
        }
      ]
    }
    Highcharts.chart('fuelingClassmentObject', this.classmentObject);
  }

}
